import { render } from "./UiPage.vue?vue&type=template&id=0be01525&ts=true"
import script from "./UiPage.vue?vue&type=script&lang=ts"
export * from "./UiPage.vue?vue&type=script&lang=ts"

import "./UiPage.vue?vue&type=style&index=0&id=0be01525&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__